type SeatWithType = { type?: string | null } | null | undefined;

/**
 * Builds a stable Monarch `courseModes` targeting string from seat types.
 *
 * Seat arrays are not guaranteed to be ordered consistently across partners
 * (e.g. IBM: "verified,audit" vs Harvard: "audit,verified"). Sorting makes
 * Monarch rule matching independent of upstream seat order.
 */
export default function getCourseModesForMonarch(
  seats: SeatWithType[] | null | undefined,
): string | undefined {
  if (!seats?.length) return undefined;

  const types = seats
    .map((seat) => seat?.type)
    .filter((type): type is string => Boolean(type));

  if (!types.length) return undefined;

  return [...new Set(types)].sort((a, b) => a.localeCompare(b)).join(",");
}
